import { Drawer } from 'antd';
import styled from 'styled-components';

export const Top = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const Handle = styled.div`
  flex: none;
  width: 40px;
  height: 4px;
  margin: 8px auto 0;
  background-color: #d9d9d9;
  border-radius: 2px;
`;

export const Header = styled.div`
  display: flex;
  flex: none;
  gap: 8px;
  align-items: flex-start;
  padding: 4px 8px 8px 16px;
`;

export const Heading = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding-top: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 16px;
  line-height: 1.3;
  font-weight: 700;
  color: #262626;
`;

export const CloseButton = styled.button`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  font-size: 16px;
  color: #262626;
  cursor: pointer;
  background: none;
  border: none;
`;

export const Content = styled.div`
  padding: 0 16px;

  &::after {
    display: block;
    height: calc(24px + env(safe-area-inset-bottom, 0px));
    content: '';
  }
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: 12px 16px calc(20px + env(safe-area-inset-bottom, 0px));
  background: #fff;
  border-top: 1px solid #d9d9d9;
`;

export const Sheet = styled(Drawer)`
  && .ant-drawer-content-wrapper {
    width: 100% !important;
  }

  && .ant-drawer-content-wrapper {
    max-height: calc(100vh - 44px);
    max-height: calc(100dvh - 44px);
  }

  && .ant-drawer-content {
    max-height: calc(100vh - 44px);
    max-height: calc(100dvh - 44px);
    border-radius: 8px 8px 0 0;
  }

  && .ant-drawer-body {
    max-height: calc(100vh - 44px);
    max-height: calc(100dvh - 44px);
    padding: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
`;

export const Summary = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  color: #595959;
`;
